import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

type SnackbarState = {
    open: boolean;
    message: string;
};

const initialState: SnackbarState = {
    open: false,
    message: '',
};

const snackbarSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setSnackbarState: (state, action: PayloadAction<{ message: string }>) => {
            state.open = true;
            state.message = action.payload.message;
        },
        clearSnackbar: (state) => {
            state.open = false;
            state.message = '';
        },
    },
});

export const { setSnackbarState, clearSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer;

const selectErrorState = (state: { error: SnackbarState }) => state.error;

export const selectSnackbarState = createSelector([selectErrorState], (errorState) => errorState);
